// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-register-shell {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.invoice-register-main {
  min-width: 0;
  min-height: 100vh;
  margin-left: 256px;
}
.invoice-register-content {
  display: flex;
  flex-direction: column;
  padding: 32px;
  box-sizing: border-box;
}
.invoice-compact-org {
  display: none;
}
.invoice-page-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px 24px;
  align-items: center;
  margin-bottom: 24px;
}
.invoice-page-header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.48px;
  font-weight: 600;
}
.invoice-page-header p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 22px;
}
.invoice-new-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: #0f766e;
  color: #fff;
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-new-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.invoice-new-button svg {
  width: 16px;
  height: 16px;
}
.invoice-page-header .invoice-scope,
.invoice-page-header .invoice-snapshot {
  margin: 0;
  font-size: 13px;
  line-height: 19px;
}
.invoice-snapshot {
  text-align: right;
}
.invoice-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
.invoice-summary-grid article {
  display: flex;
  min-height: 154px;
  box-sizing: border-box;
  flex-direction: column;
  gap: 14px;
  padding: 24px;
  border: 1px solid #dce3e2;
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.invoice-summary-grid article div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invoice-summary-grid h2 {
  margin: 0;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
}
.invoice-summary-grid svg {
  width: 20px;
  height: 20px;
  color: var(--interactive-default, #0f766e);
}
.invoice-summary-grid article > strong {
  font-family: var(--font-family-mono, monospace);
  font-size: 24px;
  line-height: 29px;
}
.invoice-summary-grid article > p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18px;
}
.invoice-summary-note {
  margin: 12px 0 24px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 19px;
}
.invoice-filter-area {
  margin-bottom: 24px;
}
.invoice-tabs {
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid #dce3e2;
}
.invoice-tabs button {
  height: 42px;
  padding: 0 16px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-primary, #102523);
  font: 500 13px var(--font-family-primary);
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease;
}
.invoice-tabs button:hover {
  color: var(--text-secondary, #506360);
  background: transparent;
  box-shadow: none;
}
.invoice-tabs button.active {
  border-bottom-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.invoice-filter-row {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}
.invoice-clear-filters {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-default);
  border-radius: 10px;
  background: var(--surface-primary);
  color: var(--text-primary);
  font: 500 13px var(--font-family-primary);
  white-space: nowrap;
  cursor: pointer;
}
.invoice-clear-filters:hover {
  background: var(--surface-secondary);
}
.invoice-clear-filters:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.invoice-filter-row label {
  margin-top: 0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 420px;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-secondary, #506360);
}
.invoice-filter-row label svg {
  width: 18px;
  height: 18px;
}
.invoice-filter-row input {
  min-width: 0;
  flex: 1 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 14px var(--font-family-primary);
}
.invoice-filter-row select {
  height: 40px;
  max-width: 190px;
  padding: 0 34px 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px var(--font-family-primary);
}
.invoice-filter-area > p {
  margin: 10px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 17px;
}
.invoice-register-card {
  overflow: visible;
  border: 1px solid #dce3e2;
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.invoice-register-context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 51px;
  padding: 0 16px;
  font-size: 13px;
}
.invoice-register-context strong {
  font-weight: 500;
}
.invoice-register-context span {
  color: var(--text-secondary, #506360);
}
.invoice-bulk-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.invoice-bulk-button {
  display: inline-flex;
  height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: 10px;
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-bulk-send {
  border: 0;
  background: #0f837a;
  color: #fff;
}
.invoice-bulk-deselect {
  border: 1px solid #cdd6d4;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}
.invoice-table-head,
.invoice-register-row {
  display: grid;
  grid-template-columns: 128px minmax(156px, 1fr) 112px 120px 120px 128px 112px 168px 64px;
  align-items: center;
}
.invoice-table-head {
  height: 44px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 500;
}
.invoice-table-head > span {
  padding: 0 12px;
}
.invoice-table-head.compact {
  display: none;
}
.invoice-register-row {
  min-height: 52px;
  border-bottom: 1px solid #dce3e2;
  font-size: 13px;
}
.invoice-register-row > * {
  min-width: 0;
  box-sizing: border-box;
  padding: 10px 12px;
}
.invoice-check input {
  width: 16px;
  height: 16px;
  margin: 0;
  border-radius: 4px;
  accent-color: var(--interactive-default, #0f766e);
  cursor: pointer;
}
.invoice-number {
  border: 0;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  text-align: left;
  font: 500 14px/19px var(--font-family-mono, monospace);
  cursor: pointer;
}
.invoice-customer {
  font-size: 14px;
  line-height: 20px;
}
.invoice-customer small,
.invoice-status small,
.invoice-balance small {
  display: block;
  margin-top: 3px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 16px;
}
.invoice-date,
.invoice-due {
  line-height: 19px;
}
.invoice-total,
.invoice-balance strong {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  line-height: 19px;
  text-align: right;
}
.invoice-balance {
  text-align: right;
}
.invoice-register-row .invoice-status,
.invoice-register-row .invoice-lifecycle-status {
  display: block;
  background: transparent;
  color: inherit;
  border-radius: 0;
  font: inherit;
}
.invoice-status i,
.invoice-lifecycle-status i {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 6px;
  border-radius: 999px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
  font-style: normal;
  white-space: nowrap;
}
.invoice-status i.overdue {
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}
.invoice-status i.awaiting {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.invoice-status i.paid {
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.invoice-status i.draft,
.invoice-status i.voided {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.invoice-lifecycle-status i {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-lifecycle-status i.draft,
.invoice-lifecycle-status i.pending {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.invoice-lifecycle-status i.approved,
.invoice-lifecycle-status i.accepted {
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
}
.invoice-row-menu {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 6px;
}
.invoice-row-menu > button {
  display: grid;
  width: 32px;
  height: 40px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.invoice-menu-popover {
  position: absolute;
  z-index: 20;
  top: 42px;
  right: 18px;
  width: 190px;
  padding: 6px;
  border: 1px solid #dce3e2;
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);
}
.invoice-menu-popover button {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-menu-popover button:hover {
  background: var(--surface-secondary, #f4f7f7);
}
.invoice-menu-popover button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: transparent;
}
.invoice-menu-popover button.danger {
  color: var(--danger-text, #a3301f);
}
.invoice-menu-popover svg {
  width: 16px;
  height: 16px;
}
.invoice-register-card footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  padding: 0 16px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.invoice-register-card footer div {
  display: flex;
  gap: 8px;
}
.invoice-register-card footer button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid #dce3e2;
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-secondary, #506360);
}
.invoice-register-card footer button:disabled {
  opacity: 0.4;
}
.invoice-empty {
  padding: 48px 20px;
  color: var(--text-secondary, #506360);
  text-align: center;
}
.invoice-register-shell.dark {
  background: #101113;
  color: var(--text-primary, #f2f3f5);
}
.invoice-register-shell.dark .invoice-summary-grid article,
.invoice-register-shell.dark .invoice-register-card,
.invoice-register-shell.dark .invoice-filter-row label,
.invoice-register-shell.dark .invoice-menu-popover {
  border-color: #2c3036;
  background: #191b1f;
  color: var(--text-primary, #f2f3f5);
}
.invoice-register-shell.dark .invoice-table-head {
  background: #22252a;
}
.invoice-register-shell.dark input {
  color: var(--text-primary, #f2f3f5);
}
.invoice-register-row--loading {
  pointer-events: none;
}
.invoice-register-row--loading > span {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 10px 12px;
}
.invoice-register-row--loading .app-skeleton {
  max-width: 100%;
}
.invoice-theme-select {
  position: relative;
  flex: 0 0 auto;
}
.invoice-theme-select > button {
  display: flex;
  height: 40px;
  min-width: 134px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px;
  border: 1px solid #cdd6d4;
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-theme-select > button svg {
  width: 16px;
  height: 16px;
  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);
}

.invoice-theme-select > button[aria-expanded="true"] svg:last-child {
  transform: rotate(180deg);
}
.invoice-theme-select.open > button {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.invoice-theme-options {
  position: absolute;
  z-index: 30;
  top: 46px;
  right: 0;
  min-width: 210px;
  padding: 6px;
  border: 1px solid #dce3e2;
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);
}
.invoice-theme-options button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 13px var(--font-family-primary);
  text-align: left;
  cursor: pointer;
}
.invoice-theme-options button:hover,
.invoice-theme-options button.selected {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-theme-options svg {
  width: 16px;
  height: 16px;
}
.invoice-selection-panel {
  display: none;
}
.invoice-clickable-row,
.invoice-register-row {
  cursor: pointer;
  transition: background-color 150ms ease;
}
.invoice-clickable-row:hover,
.invoice-register-row:hover {
  background: var(--dash-surface-2, #f4f7f7);
}
.invoice-clickable-row:focus-visible,
.invoice-register-row:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: -2px;
}
.invoice-register-shell.dark .invoice-clickable-row:hover,
.invoice-register-shell.dark .invoice-register-row:hover {
  background: #22252a;
}
.invoice-register-row.selected {
  background: var(--interactive-soft, #f0f8f7);
}
.invoice-register-shell.dark .invoice-register-row.selected {
  background: #233331;
}
.invoice-register-row--loading {
  cursor: default !important;
  pointer-events: none !important;
}
.invoice-register-shell.dark .invoice-theme-select > button,
.invoice-register-shell.dark .invoice-theme-options {
  border-color: #3a3f47;
  background: #191b1f;
  color: var(--text-primary, #f2f3f5);
}
.invoice-register-shell.dark .invoice-theme-options button {
  color: var(--text-primary, #f2f3f5);
}
.invoice-register-shell.dark .invoice-theme-options button:hover,
.invoice-register-shell.dark .invoice-theme-options button.selected {
  background: #233331;
  color: var(--interactive-hover, #83c7be);
}
@media (max-width: 1190px) {
  .invoice-table-head,
  .invoice-register-row {
    grid-template-columns: 112px minmax(132px, 1fr) 96px 104px 105px 118px 100px 138px 54px;
  }
  .invoice-register-row > * {
    padding-left: 9px;
    padding-right: 9px;
  }
  .invoice-table-head > span {
    padding: 0 9px;
  }
}
@media (max-width: 1024px) {
  .invoice-register-main {
    margin-left: 0;
  }
  .invoice-register-content {
    padding: 24px;
  }
  .invoice-compact-org {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .invoice-compact-org > button {
    display: grid;
    width: 44px;
    height: 44px;
    place-items: center;
    border: 1px solid #dce3e2;
    border-radius: 10px;
    background: var(--surface-secondary, #f4f7f7);
  }
  .invoice-compact-org > span {
    margin-right: auto;
    margin-left: 8px;
    color: var(--text-secondary, #506360);
    font-size: 13px;
  }
  .invoice-compact-org > div {
    display: flex;
    width: 220px;
    align-items: center;
    gap: 8px;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #dce3e2;
    border-radius: 10px;
    background: var(--surface-primary, #fff);
  }
  .invoice-compact-org i {
    display: grid;
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    place-items: center;
    border: 1px solid #dce3e2;
    border-radius: 50%;
    background: var(--interactive-soft, #f0f8f7);
    color: var(--interactive-default, #0f766e);
    font-size: 11px;
    font-style: normal;
  }
  .invoice-compact-org strong {
    display: flex;
    min-width: 0;
    flex: 1 1;
    flex-direction: column;
    font-size: 13px;
  }
  .invoice-compact-org small {
    margin-top: 3px;
    color: var(--text-secondary, #506360);
    font-size: 11px;
    font-weight: 400;
  }
  .invoice-page-header h1 {
    font-size: 28px;
    line-height: 35px;
  }
  .invoice-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .invoice-summary-grid article:last-child {
    grid-column: 1/-1;
  }
  .invoice-filter-row label {
    flex: 1 1;
    width: auto;
  }
  .invoice-table-head.desktop {
    display: none;
  }
  .invoice-table-head.compact {
    display: grid;
    grid-template-columns:
      minmax(210px, 1.4fr) minmax(150px, 1fr) minmax(145px, 1fr)
      54px;
  }
  .invoice-register-row {
    grid-template-columns:
      minmax(210px, 1.4fr) minmax(150px, 1fr) minmax(145px, 1fr)
      54px;
    min-height: 80px;
  }
  .invoice-register-row .invoice-number {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
    margin-top: 18px;
  }
  .invoice-register-row .invoice-customer {
    grid-column: 1;
    grid-row: 1;
    align-self: start;
    padding-bottom: 0;
  }
  .invoice-register-row .invoice-date {
    grid-column: 1;
    grid-row: 1;
    align-self: end;
    padding-top: 0;
    color: var(--text-secondary, #506360);
    font-size: 12px;
  }
  .invoice-register-row .invoice-due {
    grid-column: 2;
    grid-row: 1;
    align-self: end;
    color: var(--text-secondary, #506360);
    font-size: 12px;
  }
  .invoice-register-row .invoice-status {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
  }
  .invoice-register-row .invoice-lifecycle-status {
    grid-column: 3;
    grid-row: 1;
    align-self: start;
  }
  .invoice-register-row .invoice-total {
    grid-column: 3;
    grid-row: 1;
    align-self: start;
  }
  .invoice-register-row .invoice-balance {
    grid-column: 3;
    grid-row: 1;
    align-self: end;
  }
  .invoice-register-row .invoice-row-menu {
    grid-column: 4;
    grid-row: 1;
  }
  .invoice-register-row .invoice-check {
    grid-column: 1;
    grid-row: 1;
  }
  .invoice-menu-popover {
    right: 8px;
  }
}
@media (max-width: 600px) {
  .invoice-register-content {
    padding: 16px;
  }
  .invoice-compact-org > div {
    width: auto;
    max-width: 190px;
  }
  .invoice-compact-org > span {
    font-size: 11px;
  }
  .invoice-page-header {
    gap: 12px;
    margin-bottom: 20px;
  }
  .invoice-page-header > div p {
    max-width: 230px;
    font-size: 12px;
    line-height: 17px;
  }
  .invoice-page-header .invoice-scope,
  .invoice-page-header .invoice-snapshot {
    font-size: 11px;
  }
  .invoice-new-button {
    padding: 0 12px;
  }
  .invoice-summary-grid {
    grid-template-columns: 1fr;
  }
  .invoice-summary-grid article:last-child {
    grid-column: auto;
  }
  .invoice-summary-grid article {
    min-height: 126px;
    padding: 16px;
  }
  .invoice-summary-note {
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-tabs button {
    padding: 0 10px;
    font-size: 11px;
  }
  .invoice-filter-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .invoice-filter-row label {
    grid-column: 1/-1;
  }
  .invoice-filter-row select {
    width: 100%;
    max-width: none;
    font-size: 11px;
  }
  .invoice-register-context {
    font-size: 11px;
  }
  .invoice-register-context span {
    font-size: 10px;
  }
  .invoice-table-head.compact {
    grid-template-columns:
      minmax(120px, 1.4fr) minmax(92px, 1fr) minmax(90px, 1fr)
      36px;
    font-size: 9px;
  }
  .invoice-register-row {
    grid-template-columns:
      minmax(120px, 1.4fr) minmax(92px, 1fr) minmax(90px, 1fr)
      36px;
    min-height: 112px;
    font-size: 11px;
  }
  .invoice-register-row > * {
    padding: 10px 5px;
  }
  .invoice-check input {
    width: 14px;
    height: 14px;
  }
  .invoice-customer {
    font-size: 11px;
    line-height: 15px;
  }
  .invoice-register-row .invoice-number {
    margin-top: 20px;
    font-size: 11px;
  }
  .invoice-register-row .invoice-date,
  .invoice-register-row .invoice-due,
  .invoice-status small,
  .invoice-balance small {
    font-size: 9px;
    line-height: 13px;
  }
  .invoice-total,
  .invoice-balance strong {
    font-size: 10px;
    line-height: 14px;
  }
  .invoice-row-menu {
    padding: 4px 0;
  }
  .invoice-row-menu > button {
    width: 30px;
  }
  .invoice-menu-popover {
    right: 0;
  }
  .invoice-register-card footer {
    padding: 0 10px;
    font-size: 10px;
  }
}

@media (max-width: 1024px) and (min-width: 601px) {
  .invoice-register-row {
    min-height: 136px;
  }
  .invoice-table-head.compact {
    min-height: 64px;
  }
}

@media (max-width: 600px) {
  .invoice-theme-select {
    min-width: 0;
    width: 100%;
  }
  .invoice-theme-select > button {
    width: 100%;
    min-width: 0;
    padding: 0 10px;
    font-size: 11px;
  }
  .invoice-theme-options {
    right: auto;
    left: 0;
    width: max-content;
    max-width: calc(100vw - 32px);
  }
  .invoice-table-head.compact {
    display: none;
  }
  .invoice-register-card {
    border: 0;
    background: transparent;
    box-shadow: none;
  }
  .invoice-register-context {
    padding: 0 0 12px;
  }
  .invoice-table-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .invoice-register-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 32px;
    grid-template-rows: auto auto auto auto auto;
    min-height: 0;
    padding: 16px 12px;
    border: 1px solid #dce3e2;
    border-radius: 14px;
    background: var(--surface-primary, #fff);
  }
  .invoice-register-row > * {
    padding: 3px 0;
  }
  .invoice-register-row .invoice-number {
    grid-column: 1;
    grid-row: 1;
    margin: 0;
    align-self: auto;
    font-size: 12px;
  }
  .invoice-register-row .invoice-row-menu {
    grid-column: 2;
    grid-row: 1/3;
    align-self: center;
  }
  .invoice-register-row .invoice-customer {
    grid-column: 1;
    grid-row: 2;
    font-size: 13px;
    line-height: 18px;
  }
  .invoice-register-row .invoice-date {
    grid-column: 1/3;
    grid-row: 3;
    align-self: auto;
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-register-row .invoice-status {
    grid-column: 2;
    grid-row: 5;
    align-self: center;
  }
  .invoice-register-row .invoice-lifecycle-status {
    grid-column: 2/4;
    grid-row: 4;
    align-self: center;
  }
  .invoice-register-row .invoice-due {
    grid-column: 2/4;
    grid-row: 6;
    align-self: auto;
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-register-row .invoice-total {
    grid-column: 2;
    grid-row: 7;
    align-self: auto;
    justify-self: start;
    margin-top: 8px;
    font-size: 13px;
    text-align: left;
  }
  .invoice-register-row .invoice-total:before {
    content: "Invoice total";
    display: block;
    margin-bottom: 4px;
    color: var(--text-secondary, #506360);
    font: 400 10px/14px var(--font-family-primary);
  }
  .invoice-register-row .invoice-balance {
    grid-column: 2/4;
    grid-row: 7;
    align-self: auto;
    justify-self: end;
    margin-top: 8px;
  }
  .invoice-register-row .invoice-balance strong {
    font-size: 13px;
  }
  .invoice-register-row.selected {
    border-color: #0f8b83;
    background: var(--surface-primary, #fff);
  }
  .invoice-register-card footer {
    margin-top: 12px;
    border: 1px solid #dce3e2;
    border-radius: 10px;
    background: var(--surface-primary, #fff);
  }
  .invoice-selection-panel {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 20px;
  }
  .invoice-selection-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .invoice-selection-heading h1 {
    margin: 0;
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
  }
  .invoice-selection-heading button {
    height: 40px;
    padding: 0 12px;
    border: 1px solid #cdd6d4;
    border-radius: 10px;
    background: transparent;
    color: var(--text-primary, #142624);
    font: 500 13px var(--font-family-primary);
  }
  .invoice-selection-panel article {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid #dce3e2;
    border-radius: 14px;
    background: var(--surface-primary, #fff);
  }
  .invoice-selection-panel article div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .invoice-selection-panel article svg {
    color: var(--interactive-default, #0f766e);
  }
  .invoice-selection-panel article b {
    font-family: var(--font-family-mono, monospace);
    font-size: 24px;
  }
  .invoice-selection-panel article p {
    margin: 0;
    color: var(--text-secondary, #506360);
    font-size: 13px;
  }
  .invoice-reminder-button {
    height: 44px;
    border: 0;
    border-radius: 10px;
    background: #0f837a;
    color: #fff;
    font: 500 13px var(--font-family-primary);
  }
  .selection-active .invoice-page-header,
  .selection-active .invoice-summary-grid,
  .selection-active .invoice-summary-note,
  .selection-active .invoice-filter-area,
  .selection-active .invoice-register-context,
  .selection-active .invoice-register-card footer {
    display: none;
  }
  .selection-active .invoice-register-row:not(.selected) {
    display: none;
  }
  .selection-active .invoice-register-card {
    background: transparent;
  }
}

/* Figma mobile invoice register (721:143044 / 721:146141). */
.invoice-select-button,
.invoice-selection-guidance {
  display: none;
}

@media (max-width: 600px) {
  .invoice-register-content {
    padding: 16px 12px 24px;
  }
  .invoice-compact-org {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 0 20px;
  }
  .invoice-compact-org > button {
    display: none;
  }
  .invoice-compact-org > span {
    margin: 0;
    color: var(--text-secondary, #506360);
    font-size: 10px;
    line-height: 14px;
  }
  .invoice-compact-org > div {
    width: 100%;
    max-width: none;
    min-height: 64px;
    padding: 10px 12px;
    border-radius: 10px;
  }
  .invoice-compact-org strong {
    font-size: 13px;
    line-height: 18px;
  }
  .invoice-compact-org small {
    margin-top: 0;
    font-size: 10px;
    line-height: 14px;
  }

  .invoice-page-header {
    grid-template-columns: 1fr auto;
    gap: 10px 12px;
    margin-bottom: 20px;
  }
  .invoice-page-header > div {
    grid-column: 1/-1;
  }
  .invoice-page-header h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.25px;
  }
  .invoice-page-header > div p {
    max-width: none;
    margin-top: 2px;
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-new-button {
    grid-column: 1/-1;
    grid-row: 2;
    width: 100%;
    height: 40px;
  }
  .invoice-page-header .invoice-scope,
  .invoice-page-header .invoice-snapshot {
    margin: 0;
    font-size: 10px;
    line-height: 15px;
  }
  .invoice-page-header .invoice-scope {
    grid-column: 1;
    grid-row: 3;
  }
  .invoice-page-header .invoice-snapshot {
    grid-column: 2;
    grid-row: 3;
    align-self: start;
    white-space: nowrap;
  }

  .invoice-summary-grid {
    gap: 10px;
  }
  .invoice-summary-grid article {
    min-height: 116px;
    gap: 10px;
    padding: 14px;
    border-radius: 10px;
  }
  .invoice-summary-grid h2 {
    font-size: 15px;
    line-height: 21px;
  }
  .invoice-summary-grid article > strong {
    font-size: 20px;
    line-height: 25px;
  }
  .invoice-summary-grid article > p {
    font-size: 10px;
    line-height: 15px;
  }
  .invoice-summary-note {
    margin: 10px 0 18px;
  }

  .invoice-filter-area {
    margin-bottom: 20px;
  }
  .invoice-tabs {
    margin: 0 -12px;
    padding: 0 12px;
  }
  .invoice-tabs button {
    height: 36px;
    padding: 0 8px;
    font-size: 9px;
  }
  .invoice-filter-row {
    gap: 8px;
    margin-top: 10px;
  }
  .invoice-filter-row label,
  .invoice-clear-filters,
  .invoice-theme-select > button {
    height: 36px;
    border-radius: 8px;
  }
  .invoice-filter-row input,
  .invoice-clear-filters,
  .invoice-theme-select > button {
    font-size: 10px;
  }
  .invoice-filter-area > p {
    margin-top: 8px;
    font-size: 9px;
    line-height: 14px;
  }

  .invoice-register-context {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
    height: auto;
    padding: 0 0 12px;
  }
  .invoice-register-context strong {
    font-size: 11px;
  }
  .invoice-register-context span {
    grid-column: 1/-1;
    grid-row: 2;
    font-size: 9px;
  }
  .invoice-select-button {
    display: inline-flex;
    grid-column: 2;
    grid-row: 1;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 10px;
    border: 1px solid #cdd6d4;
    border-radius: 8px;
    background: var(--surface-primary, #fff);
    color: var(--text-primary, #142624);
    font: 500 10px var(--font-family-primary);
  }

  .invoice-table-body {
    gap: 8px;
  }
  .invoice-register-row {
    grid-template-columns: minmax(0, 1fr) 28px;
    grid-template-rows: repeat(7, auto);
    gap: 0;
    padding: 12px;
    border-radius: 10px;
  }
  .invoice-register-row .invoice-number {
    grid-column: 1;
    grid-row: 1;
    font-size: 10px;
    line-height: 15px;
  }
  .invoice-register-row .invoice-row-menu {
    grid-column: 2;
    grid-row: 1/3;
    align-self: start;
  }
  .invoice-register-row .invoice-customer {
    grid-column: 1;
    grid-row: 2;
    font-size: 10px;
    line-height: 15px;
  }
  .invoice-customer small {
    margin-top: 2px;
    font-size: 9px;
    line-height: 14px;
  }
  .invoice-register-row .invoice-lifecycle-status {
    grid-column: 1/-1;
    grid-row: 3;
    margin-top: 4px;
  }
  .invoice-register-row .invoice-due {
    grid-column: 1/-1;
    grid-row: 4;
    margin-top: 2px;
    font-size: 9px;
    line-height: 14px;
  }
  .invoice-register-row .invoice-status {
    grid-column: 1/-1;
    grid-row: 5;
    margin-top: 2px;
  }
  .invoice-register-row .invoice-date {
    grid-column: 1/-1;
    grid-row: 6;
    margin-top: 3px;
    font-size: 9px;
    line-height: 14px;
  }
  .invoice-register-row .invoice-date:before {
    content: "Invoice date ";
    color: var(--text-secondary, #506360);
  }
  .invoice-register-row .invoice-total {
    grid-column: 1;
    grid-row: 7;
    margin-top: 6px;
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-register-row .invoice-total:before {
    margin-bottom: 1px;
    font-size: 8px;
    line-height: 12px;
  }
  .invoice-register-row .invoice-balance {
    grid-column: 2;
    grid-row: 7;
    margin-top: 6px;
  }
  .invoice-register-row .invoice-balance small {
    margin: 0 0 1px;
    font-size: 8px;
    line-height: 12px;
  }
  .invoice-register-row .invoice-balance strong {
    font-size: 11px;
    line-height: 16px;
  }
  .invoice-row-menu > button {
    height: 24px;
  }
  .invoice-register-card footer {
    display: none;
  }

  .selection-active .invoice-page-header {
    display: grid;
  }
  .selection-active .invoice-page-header .invoice-new-button {
    display: none;
  }
  .selection-active .invoice-page-header .invoice-scope {
    grid-row: 2;
  }
  .selection-active .invoice-page-header .invoice-snapshot {
    grid-row: 2;
  }
  .selection-active .invoice-summary-grid,
  .selection-active .invoice-summary-note,
  .selection-active .invoice-filter-area,
  .selection-active .invoice-register-context {
    display: none;
  }
  .invoice-selection-panel {
    gap: 12px;
    margin-bottom: 12px;
  }
  .invoice-selection-heading h1 {
    font-size: 14px;
    line-height: 20px;
  }
  .invoice-selection-heading button {
    height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    font-size: 10px;
  }
  .invoice-selection-panel article {
    gap: 8px;
    padding: 12px;
    border-radius: 10px;
  }
  .invoice-selection-panel article strong,
  .invoice-selection-panel article p {
    font-size: 10px;
    line-height: 15px;
  }
  .invoice-selection-panel article b {
    font-size: 18px;
    line-height: 24px;
  }
  .invoice-reminder-button {
    height: 38px;
    border-radius: 8px;
    font-size: 11px;
  }
  .selection-active .invoice-register-row .invoice-check {
    display: block;
  }
  .invoice-selection-guidance {
    margin: 10px 0 0;
    color: var(--text-secondary, #506360);
    font-size: 9px;
    line-height: 14px;
  }
  .selection-active .invoice-selection-guidance {
    display: block;
  }
}

.invoice-check input:disabled {
  background: var(--surface-tertiary, #e8edec);
  border-color: var(--border-subtle, #dce3e2);
  cursor: not-allowed;
  opacity: 0.65;
}
/* Keep register headings and row contents on matching column edges. */
@media (min-width: 1024px) {
  .invoice-register-card {
    --invoice-register-columns: minmax(112px, 1fr) minmax(150px, 1.35fr)
      minmax(100px, 0.9fr) minmax(112px, 0.95fr) minmax(108px, 0.95fr)
      minmax(124px, 1.05fr) minmax(104px, 0.9fr) minmax(144px, 1.15fr) 64px;
  }
  .invoice-register-card .invoice-table-head.desktop,
  .invoice-register-card .invoice-register-row {
    grid-template-columns: var(--invoice-register-columns);
  }
  .invoice-register-card .invoice-table-head.desktop > span,
  .invoice-register-card .invoice-register-row > * {
    padding-inline: 16px;
    text-align: left;
  }
  .invoice-register-card .invoice-table-head.desktop > span:nth-child(7),
  .invoice-register-card .invoice-table-head.desktop > span:nth-child(8),
  .invoice-register-card .invoice-register-row .invoice-total,
  .invoice-register-card .invoice-register-row .invoice-balance {
    text-align: right;
  }
  .invoice-register-card .invoice-table-head.desktop > span:last-child {
    padding-inline: 8px;
    text-align: center;
  }
  .invoice-register-card .invoice-register-row .invoice-row-menu {
    justify-content: center;
    padding-inline: 8px;
  }
  .invoice-register-card .invoice-number,
  .invoice-register-card .invoice-customer {
    white-space: normal;
    overflow-wrap: break-word;
  }
}
@media (min-width: 601px) {
  .invoice-register-card .invoice-table-head > span.invoice-check,
  .invoice-register-card .invoice-register-row > .invoice-check {
    text-align: center;
  }
}
@media (min-width: 601px) and (max-width: 1024px) {
  .invoice-register-card .invoice-table-head.compact > span,
  .invoice-register-card .invoice-register-row > * {
    padding-inline: 12px;
  }
  .invoice-register-card .invoice-table-head.compact > span:nth-child(4),
  .invoice-register-card .invoice-table-head.compact > span:last-child {
    text-align: right;
  }
  .invoice-register-card .invoice-register-row .invoice-row-menu {
    justify-content: flex-end;
  }
}
.invoice-empty {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 32px 20px;
  color: var(--text-secondary, #506360);
  text-align: center;
}
.invoice-empty > svg {
  width: 28px;
  height: 28px;
  color: var(--interactive-default, #0f766e);
}
.invoice-empty > strong {
  color: var(--text-primary, #142624);
  font-size: 16px;
  font-weight: 500;
}
.invoice-empty > span {
  font-size: 13px;
}
.invoice-empty > button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 0 14px;
  border: 1px solid var(--interactive-default, #0f766e);
  border-radius: 9px;
  background: var(--surface-primary, #fff);
  color: var(--interactive-default, #0f766e);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.invoice-empty > button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

/* Create Invoice Type Modal — Figma Node 1898:111001 */
.invoice-creation-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(20, 38, 36, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: invoiceFadeIn 0.2s ease-out;
}

/* The global .dark background is opaque and !important. Keep this backdrop
   translucent so the existing blur can sample the page in dark mode too. */
.invoice-creation-modal-backdrop.dark {
  background-color: var(--overlay-default) !important;
}

@keyframes invoiceFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.invoice-creation-modal {
  width: 100%;
  max-width: 640px;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #dce3e2;
  box-shadow: 0 20px 40px -8px rgba(20, 38, 36, 0.16);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.invoice-creation-modal > :not(.invoice-creation-modal-body) {
  flex-shrink: 0;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-modal {
  background: #1b2423;
  border-color: #2e3d3b;
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.4);
}

/* Header */
.invoice-creation-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 28px 20px 28px;
}

.invoice-creation-modal-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.invoice-creation-header-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #15703d;
  flex-shrink: 0;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-header-icon {
  color: #4ade80;
}

.invoice-creation-modal-header-left h2 {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-modal-header-left h2 {
  color: #f0f4f3;
}

.invoice-creation-modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #506360;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.invoice-creation-modal-close:hover {
  background: #f4f7f7;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-modal-close {
  color: #9eaeac;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-modal-close:hover {
  background: #243331;
  color: #f0f4f3;
}

.invoice-creation-divider {
  height: 1px;
  background: #dce3e2;
  width: 100%;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-divider {
  background: #2e3d3b;
}

/* Subtitle Description */
.invoice-creation-description {
  margin: 0;
  padding: 24px 28px 0 28px;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-description {
  color: #9eaeac;
}

/* Body */
.invoice-creation-modal-body {
  padding: 24px 28px;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Options Grid */
.invoice-creation-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 540px) {
  .invoice-creation-options-grid {
    grid-template-columns: 1fr;
  }
}

.invoice-creation-card {
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #cdd6d4;
  background: #f4f7f7;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-card {
  border-color: #2e3d3b;
  background: #141e1d;
}

.invoice-creation-card:hover {
  border-color: #0f766e;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-card:hover {
  border-color: #14b8a6;
}

.invoice-creation-card.is-selected {
  border: 1px solid #0f766e;
  background: #f0f8f7;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-card.is-selected {
  border-color: #14b8a6;
  background: rgba(15, 118, 110, 0.2);
}

.invoice-creation-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.invoice-creation-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #cdd6d4;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invoice-creation-card.is-selected .invoice-creation-radio {
  border-color: #0f766e;
  background: #0f766e;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-radio {
  border-color: #4a5f5c;
  background: #141e1d;
}

.invoice-creation-modal-backdrop.dark
  .invoice-creation-card.is-selected
  .invoice-creation-radio {
  border-color: #14b8a6;
  background: #14b8a6;
}

.invoice-creation-radio .radio-inner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
}

.invoice-creation-card-icon {
  font-size: 20px;
  color: #0f766e;
  display: flex;
  align-items: center;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-card-icon {
  color: #14b8a6;
}

.invoice-creation-card-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.choice-title {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 19.5px;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .choice-title {
  color: #f0f4f3;
}

.choice-description {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .choice-description {
  color: #9eaeac;
}

/* Quotation Selection Flow */
.invoice-creation-quote-flow {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invoice-creation-dropdown-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.invoice-creation-label-row {
  display: flex;
  align-items: center;
  gap: 2px;
}

.invoice-creation-label {
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16.25px;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-label {
  color: #f0f4f3;
}

.required-marker {
  color: #c23a2b;
  font-weight: 500;
}

.invoice-creation-trigger-container {
  position: relative;
  height: var(--control-md, 40px);
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #cdd6d4;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-radius: 4px;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  line-height: 17.5px;
  color: #142624;
  cursor: pointer;
  transition: background 0.1s ease;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item {
  color: #f0f4f3;
}

.dropdown-menu-item:hover:not(.is-disabled) {
  background: #f4f7f7;
}

.invoice-creation-modal-backdrop.dark
  .dropdown-menu-item:hover:not(.is-disabled) {
  background: #243331;
}

.dropdown-menu-item.is-selected {
  background: #f0f8f7;
  color: #0f766e;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-selected {
  background: rgba(15, 118, 110, 0.25);
  color: #2dd4bf;
}

.dropdown-menu-item.is-disabled {
  color: #8a9896;
  cursor: not-allowed;
  background: transparent;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-disabled {
  color: #657976;
}

.dropdown-item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-item-check {
  font-size: 16px;
  color: #0f766e;
  flex-shrink: 0;
  margin-left: 8px;
}

.invoice-creation-modal-backdrop.dark .dropdown-item-check {
  color: #2dd4bf;
}

.dropdown-loading-item,
.dropdown-empty-item {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-trigger-container {
  background: #141e1d;
  border-color: #2e3d3b;
}

.invoice-creation-trigger-container.is-active,
.invoice-creation-trigger-container:focus-within {
  border-color: #0f766e;
  box-shadow: none;
}

.invoice-creation-modal-backdrop.dark
  .invoice-creation-trigger-container.is-active,
.invoice-creation-modal-backdrop.dark
  .invoice-creation-trigger-container:focus-within {
  border-color: #14b8a6;
  box-shadow: none;
}

.trigger-search-icon {
  font-size: 16px;
  color: #506360;
  flex-shrink: 0;
}

.invoice-creation-modal-backdrop.dark .trigger-search-icon {
  color: #9eaeac;
}

.trigger-search-input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1 1;
  min-width: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  line-height: 17.5px;
  color: #142624;
  width: 100%;
}

.trigger-search-input::placeholder {
  color: #6b7b78;
}

.invoice-creation-modal-backdrop.dark .trigger-search-input {
  color: #f0f4f3;
}

.invoice-creation-modal-backdrop.dark .trigger-search-input::placeholder {
  color: #7e9290;
}

.trigger-chevron {
  font-size: 16px;
  color: #506360;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.trigger-chevron.open {
  transform: rotate(180deg);
}

.invoice-creation-trigger-container .invoice-quotation-search-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 var(--control-sm, 32px);
  width: var(--control-sm, 32px);
  height: var(--control-sm, 32px);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.invoice-quotation-search-toggle:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.invoice-creation-dropdown-menu .dropdown-menu-item.is-active {
  background: var(--interactive-soft, #f0f8f7);
}

.invoice-creation-modal-backdrop.dark .trigger-chevron {
  color: #9eaeac;
}

.invoice-creation-guidance {
  margin: 4px 0 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-guidance {
  color: #9eaeac;
}

/* Dropdown Menu */
.invoice-creation-dropdown-menu {
  position: fixed;
  box-sizing: border-box;
  z-index: 1300;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #cdd6d4;
  box-shadow: 0 10px 24px -4px rgba(20, 38, 36, 0.12);
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: min(240px, 30vh);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.invoice-creation-dropdown-menu .dropdown-menu-item {
  min-height: 36px;
  flex-shrink: 0;
  gap: 8px;
  padding: 8px 10px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.invoice-creation-dropdown-menu .dropdown-item-label {
  min-width: 0;
  font: inherit;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-dropdown-menu {
  background: #1b2423;
  border-color: #2e3d3b;
  box-shadow: 0 10px 24px -4px rgba(0, 0, 0, 0.4);
}

.dropdown-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-radius: 4px;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  line-height: 17.5px;
  color: #142624;
  cursor: pointer;
  transition: background 0.1s ease;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item {
  color: #f0f4f3;
}

.dropdown-menu-item:hover:not(.is-disabled) {
  background: #f4f7f7;
}

.invoice-creation-modal-backdrop.dark
  .dropdown-menu-item:hover:not(.is-disabled) {
  background: #243331;
}

.dropdown-menu-item.is-selected {
  background: #f0f8f7;
  color: #0f766e;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-selected {
  background: rgba(15, 118, 110, 0.25);
  color: #2dd4bf;
}

.dropdown-menu-item.is-disabled {
  color: #8a9896;
  cursor: not-allowed;
  background: transparent;
}

.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-disabled {
  color: #657976;
}

.dropdown-item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-item-check {
  font-size: 16px;
  color: #0f766e;
  flex-shrink: 0;
  margin-left: 8px;
}

.invoice-creation-modal-backdrop.dark .dropdown-item-check {
  color: #2dd4bf;
}

.dropdown-loading-item,
.dropdown-empty-item {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .dropdown-loading-item,
.invoice-creation-modal-backdrop.dark .dropdown-empty-item {
  color: #9eaeac;
}

/* Selected Quotation Preview Section */
.invoice-creation-preview-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.preview-section-title {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .preview-section-title {
  color: #f0f4f3;
}

.invoice-creation-preview-card {
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #cdd6d4;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-preview-card {
  background: #141e1d;
  border-color: #2e3d3b;
}

.preview-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preview-quote-number {
  font-family: "JetBrains Mono", "Roboto Mono", monospace;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .preview-quote-number {
  color: #f0f4f3;
}

.preview-badge-accepted {
  border-radius: 999px;
  background: #edfbf2;
  padding: 3px 10px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.invoice-creation-modal-backdrop.dark .preview-badge-accepted {
  background: rgba(21, 112, 61, 0.25);
}

.preview-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #15703d;
}

.invoice-creation-modal-backdrop.dark .preview-badge-dot {
  background: #4ade80;
}

.preview-badge-label {
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  color: #115a33;
}

.invoice-creation-modal-backdrop.dark .preview-badge-label {
  color: #4ade80;
}

.preview-client-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.preview-avatar {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #f0f8f7;
  border: 1px solid #dce3e2;
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.invoice-creation-modal-backdrop.dark .preview-avatar {
  background: #1e2d2b;
  border-color: #2e3d3b;
  color: #2dd4bf;
}

.preview-client-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.preview-client-name {
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .preview-client-name {
  color: #f0f4f3;
}

.preview-dates-line {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .preview-dates-line {
  color: #9eaeac;
}

.preview-items-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 4px;
}

.preview-item-row {
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .preview-item-row {
  color: #9eaeac;
}

.preview-subtotal-line {
  margin: 4px 0 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .preview-subtotal-line {
  color: #9eaeac;
}

.preview-card-divider {
  height: 1px;
  background: #dce3e2;
  width: 100%;
}

.invoice-creation-modal-backdrop.dark .preview-card-divider {
  background: #2e3d3b;
}

.preview-card-footer {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.preview-total-amount {
  font-family: "JetBrains Mono", "Roboto Mono", monospace;
  font-size: 16px;
  font-weight: 600;
  color: #142624;
}

.invoice-creation-modal-backdrop.dark .preview-total-amount {
  color: #f0f4f3;
}

.preview-total-label {
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  color: #6b7b78;
}

.invoice-creation-modal-backdrop.dark .preview-total-label {
  color: #7e9290;
}

.invoice-conversion-rule-note {
  margin: 0;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.2px;
  color: #506360;
}

.invoice-creation-modal-backdrop.dark .invoice-conversion-rule-note {
  color: #9eaeac;
}

/* Footer */
.invoice-creation-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 28px;
}

.invoice-creation-btn-cancel {
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  border: 1px solid #cdd6d4;
  background: #ffffff;
  color: #142624;
  cursor: pointer;
  transition: all 0.15s ease;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-btn-cancel {
  border-color: #2e3d3b;
  background: #1e2d2b;
  color: #f0f4f3;
}

.invoice-creation-btn-cancel:hover {
  background: #f4f7f7;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-btn-cancel:hover {
  background: #263836;
}

.invoice-creation-btn-submit {
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  border: none;
  background: #0f766e;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.invoice-creation-btn-submit:hover:not(:disabled) {
  background: #0d645d;
}

.invoice-creation-btn-submit:disabled {
  background: #cdd6d4;
  color: #8a9896;
  cursor: not-allowed;
}

.invoice-creation-modal-backdrop.dark .invoice-creation-btn-submit:disabled {
  background: #2e3d3b;
  color: #7e9290;
}

.invoice-register-row:not(.invoice-register-row--loading) {
  cursor: pointer;
}
.invoice-register-row:not(.invoice-register-row--loading):hover {
  background: var(--surface-secondary, #f4f7f7);
}
.invoice-register-row.selected:hover {
  background: #f0f8f7;
}
.invoice-register-shell.dark
  .invoice-register-row:not(.invoice-register-row--loading):hover {
  background: #22252a;
}
.invoice-contact-link {
  color: var(--text-primary, #142624);
  font: inherit;
  text-decoration: none;
  text-underline-offset: 2px;
}
.invoice-contact-link:hover {
  text-decoration: underline !important;
  color: var(--text-link, #0f766e);
}
.invoice-contact-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.invoice-register-shell .invoice-theme-select.open > button,
.invoice-register-shell .invoice-theme-select > button:focus-visible,
.invoice-register-shell .invoice-filter-row > label:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
  outline: none;
}

.invoice-register-shell
  .invoice-theme-select:has(> button[aria-label="Customer filter"])
  > .invoice-theme-options {
  box-sizing: border-box;
  max-height: min(240px, 40vh);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.invoice-bank-gate-backdrop {
  position: fixed;
  z-index: 1500;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--overlay-default, rgba(10, 22, 20, 0.44));
}

.invoice-bank-gate-dialog {
  width: min(520px, 100%);
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-xl, 20px);
  background: var(--surface-elevated, #fff);
  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1),
    0 1px 1px rgba(14, 26, 32, 0.04);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}

.invoice-bank-gate-dialog header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 28px 28px 20px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.invoice-bank-gate-dialog header > svg {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  color: var(--interactive-default, #0f766e);
}

.invoice-bank-gate-dialog h2 {
  flex: 1 1;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
}

.invoice-bank-gate-dialog header button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.invoice-bank-gate-dialog header button svg {
  width: 20px;
  height: 20px;
}

.invoice-bank-gate-copy {
  padding: 24px 28px 0;
}

.invoice-bank-gate-copy p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 22px;
}

.invoice-bank-gate-dialog footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 28px;
}

.invoice-bank-gate-dialog footer button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  font: 500 13px/17px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}

.invoice-bank-gate-secondary {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}

.invoice-bank-gate-primary {
  border: 1px solid var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}

@media (max-width: 560px) {
  .invoice-bank-gate-dialog header,
  .invoice-bank-gate-copy,
  .invoice-bank-gate-dialog footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .invoice-bank-gate-dialog h2 {
    font-size: 18px;
    line-height: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Invoices/invoices.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,6DAA6D;AAC/D;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wDAAwD;EACxD,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,SAAO;EACP,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,aAAa;EACb,wFAAwF;EACxF,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;AACjB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,sDAAsD;EACtD,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;;EAEE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;;EAEE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;AACA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8EAA8E;AAChF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;EAEE,eAAe;EACf,uCAAuC;AACzC;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,sDAAsD;EACtD,oBAAoB;AACtB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE;;IAEE,uFAAuF;EACzF;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;EAC/C;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,0CAA0C;IAC1C,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,YAAY;IACZ,SAAO;IACP,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,eAAe;IACf,qCAAqC;IACrC,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gDAAgD;IAChD,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAO;IACP,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb;;UAEM;EACR;EACA;IACE;;UAEM;IACN,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE;;UAEM;IACN,cAAc;EAChB;EACA;IACE;;UAEM;IACN,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;;;;IAIE,cAAc;IACd,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,0CAA0C;IAC1C,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,cAAc;IACd,kBAAkB;IAClB,qCAAqC;IACrC,8CAA8C;EAChD;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,yCAAyC;EAC3C;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,+CAA+C;IAC/C,eAAe;EACjB;EACA;IACE,SAAS;IACT,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,yCAAyC;EAC3C;EACA;;;;;;IAME,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,6DAA6D;AAC7D;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,qCAAqC;IACrC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;;IAEE,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;EACA;IACE,QAAQ;IACR,gBAAgB;EAClB;EACA;;;IAGE,YAAY;IACZ,kBAAkB;EACpB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,QAAQ;IACR,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,mCAAmC;IACnC,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;EACV;EACA;IACE,0CAA0C;IAC1C,mCAAmC;IACnC,MAAM;IACN,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,qCAAqC;EACvC;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;;;IAIE,aAAa;EACf;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,QAAQ;IACR,aAAa;IACb,mBAAmB;EACrB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;AACA,sEAAsE;AACtE;EACE;IACE;;2EAEuE;EACzE;EACA;;IAEE,sDAAsD;EACxD;EACA;;IAEE,oBAAoB;IACpB,gBAAgB;EAClB;EACA;;;;IAIE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;;IAEE,oBAAoB;EACtB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,qDAAqD;EACrD,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;2EAC2E;AAC3E;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,SAAS;EACT,yBAAyB;EACzB,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,oEAAoE;EACpE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,YAAY;EACZ,oEAAoE;EACpE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;EAC/B,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,oEAAoE;EACpE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oEAAoE;EACpE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oEAAoE;EACpE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oEAAoE;EACpE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;;EAGE,iDAAiD;EACjD,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,yCAAyC;EACzC;oCACkC;EAClC,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".invoice-register-shell {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.invoice-register-main {\n  min-width: 0;\n  min-height: 100vh;\n  margin-left: 256px;\n}\n.invoice-register-content {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  box-sizing: border-box;\n}\n.invoice-compact-org {\n  display: none;\n}\n.invoice-page-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px 24px;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.invoice-page-header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  font-weight: 600;\n}\n.invoice-page-header p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 22px;\n}\n.invoice-new-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 10px;\n  background: #0f766e;\n  color: #fff;\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-new-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.invoice-new-button svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-page-header .invoice-scope,\n.invoice-page-header .invoice-snapshot {\n  margin: 0;\n  font-size: 13px;\n  line-height: 19px;\n}\n.invoice-snapshot {\n  text-align: right;\n}\n.invoice-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n}\n.invoice-summary-grid article {\n  display: flex;\n  min-height: 154px;\n  box-sizing: border-box;\n  flex-direction: column;\n  gap: 14px;\n  padding: 24px;\n  border: 1px solid #dce3e2;\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.invoice-summary-grid article div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.invoice-summary-grid h2 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 25px;\n  font-weight: 500;\n}\n.invoice-summary-grid svg {\n  width: 20px;\n  height: 20px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-summary-grid article > strong {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 24px;\n  line-height: 29px;\n}\n.invoice-summary-grid article > p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18px;\n}\n.invoice-summary-note {\n  margin: 12px 0 24px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 19px;\n}\n.invoice-filter-area {\n  margin-bottom: 24px;\n}\n.invoice-tabs {\n  display: flex;\n  overflow-x: auto;\n  border-bottom: 1px solid #dce3e2;\n}\n.invoice-tabs button {\n  height: 42px;\n  padding: 0 16px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-primary, #102523);\n  font: 500 13px var(--font-family-primary);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.invoice-tabs button:hover {\n  color: var(--text-secondary, #506360);\n  background: transparent;\n  box-shadow: none;\n}\n.invoice-tabs button.active {\n  border-bottom-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-filter-row {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n}\n.invoice-clear-filters {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default);\n  border-radius: 10px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: 500 13px var(--font-family-primary);\n  white-space: nowrap;\n  cursor: pointer;\n}\n.invoice-clear-filters:hover {\n  background: var(--surface-secondary);\n}\n.invoice-clear-filters:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.invoice-filter-row label {\n  margin-top: 0 !important;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 420px;\n  height: 40px;\n  box-sizing: border-box;\n  padding: 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-secondary, #506360);\n}\n.invoice-filter-row label svg {\n  width: 18px;\n  height: 18px;\n}\n.invoice-filter-row input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 14px var(--font-family-primary);\n}\n.invoice-filter-row select {\n  height: 40px;\n  max-width: 190px;\n  padding: 0 34px 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px var(--font-family-primary);\n}\n.invoice-filter-area > p {\n  margin: 10px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-register-card {\n  overflow: visible;\n  border: 1px solid #dce3e2;\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.invoice-register-context {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 51px;\n  padding: 0 16px;\n  font-size: 13px;\n}\n.invoice-register-context strong {\n  font-weight: 500;\n}\n.invoice-register-context span {\n  color: var(--text-secondary, #506360);\n}\n.invoice-bulk-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-bulk-button {\n  display: inline-flex;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 14px;\n  border-radius: 10px;\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-bulk-send {\n  border: 0;\n  background: #0f837a;\n  color: #fff;\n}\n.invoice-bulk-deselect {\n  border: 1px solid #cdd6d4;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n.invoice-table-head,\n.invoice-register-row {\n  display: grid;\n  grid-template-columns: 128px minmax(156px, 1fr) 112px 120px 120px 128px 112px 168px 64px;\n  align-items: center;\n}\n.invoice-table-head {\n  height: 44px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 500;\n}\n.invoice-table-head > span {\n  padding: 0 12px;\n}\n.invoice-table-head.compact {\n  display: none;\n}\n.invoice-register-row {\n  min-height: 52px;\n  border-bottom: 1px solid #dce3e2;\n  font-size: 13px;\n}\n.invoice-register-row > * {\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 10px 12px;\n}\n.invoice-check input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  border-radius: 4px;\n  accent-color: var(--interactive-default, #0f766e);\n  cursor: pointer;\n}\n.invoice-number {\n  border: 0;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  text-align: left;\n  font: 500 14px/19px var(--font-family-mono, monospace);\n  cursor: pointer;\n}\n.invoice-customer {\n  font-size: 14px;\n  line-height: 20px;\n}\n.invoice-customer small,\n.invoice-status small,\n.invoice-balance small {\n  display: block;\n  margin-top: 3px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 16px;\n}\n.invoice-date,\n.invoice-due {\n  line-height: 19px;\n}\n.invoice-total,\n.invoice-balance strong {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  line-height: 19px;\n  text-align: right;\n}\n.invoice-balance {\n  text-align: right;\n}\n.invoice-register-row .invoice-status,\n.invoice-register-row .invoice-lifecycle-status {\n  display: block;\n  background: transparent;\n  color: inherit;\n  border-radius: 0;\n  font: inherit;\n}\n.invoice-status i,\n.invoice-lifecycle-status i {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n  font-style: normal;\n  white-space: nowrap;\n}\n.invoice-status i.overdue {\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n.invoice-status i.awaiting {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.invoice-status i.paid {\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.invoice-status i.draft,\n.invoice-status i.voided {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.invoice-lifecycle-status i {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-lifecycle-status i.draft,\n.invoice-lifecycle-status i.pending {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.invoice-lifecycle-status i.approved,\n.invoice-lifecycle-status i.accepted {\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n}\n.invoice-row-menu {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: 6px;\n}\n.invoice-row-menu > button {\n  display: grid;\n  width: 32px;\n  height: 40px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.invoice-menu-popover {\n  position: absolute;\n  z-index: 20;\n  top: 42px;\n  right: 18px;\n  width: 190px;\n  padding: 6px;\n  border: 1px solid #dce3e2;\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);\n}\n.invoice-menu-popover button {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 9px;\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-menu-popover button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.invoice-menu-popover button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: transparent;\n}\n.invoice-menu-popover button.danger {\n  color: var(--danger-text, #a3301f);\n}\n.invoice-menu-popover svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-register-card footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 50px;\n  padding: 0 16px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.invoice-register-card footer div {\n  display: flex;\n  gap: 8px;\n}\n.invoice-register-card footer button {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 1px solid #dce3e2;\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-secondary, #506360);\n}\n.invoice-register-card footer button:disabled {\n  opacity: 0.4;\n}\n.invoice-empty {\n  padding: 48px 20px;\n  color: var(--text-secondary, #506360);\n  text-align: center;\n}\n.invoice-register-shell.dark {\n  background: #101113;\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-register-shell.dark .invoice-summary-grid article,\n.invoice-register-shell.dark .invoice-register-card,\n.invoice-register-shell.dark .invoice-filter-row label,\n.invoice-register-shell.dark .invoice-menu-popover {\n  border-color: #2c3036;\n  background: #191b1f;\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-register-shell.dark .invoice-table-head {\n  background: #22252a;\n}\n.invoice-register-shell.dark input {\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-register-row--loading {\n  pointer-events: none;\n}\n.invoice-register-row--loading > span {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding: 10px 12px;\n}\n.invoice-register-row--loading .app-skeleton {\n  max-width: 100%;\n}\n.invoice-theme-select {\n  position: relative;\n  flex: 0 0 auto;\n}\n.invoice-theme-select > button {\n  display: flex;\n  height: 40px;\n  min-width: 134px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 0 12px;\n  border: 1px solid #cdd6d4;\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-theme-select > button svg {\n  width: 16px;\n  height: 16px;\n  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);\n}\n\n.invoice-theme-select > button[aria-expanded=\"true\"] svg:last-child {\n  transform: rotate(180deg);\n}\n.invoice-theme-select.open > button {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.invoice-theme-options {\n  position: absolute;\n  z-index: 30;\n  top: 46px;\n  right: 0;\n  min-width: 210px;\n  padding: 6px;\n  border: 1px solid #dce3e2;\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);\n}\n.invoice-theme-options button {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 13px var(--font-family-primary);\n  text-align: left;\n  cursor: pointer;\n}\n.invoice-theme-options button:hover,\n.invoice-theme-options button.selected {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-theme-options svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-selection-panel {\n  display: none;\n}\n.invoice-clickable-row,\n.invoice-register-row {\n  cursor: pointer;\n  transition: background-color 150ms ease;\n}\n.invoice-clickable-row:hover,\n.invoice-register-row:hover {\n  background: var(--dash-surface-2, #f4f7f7);\n}\n.invoice-clickable-row:focus-visible,\n.invoice-register-row:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n}\n.invoice-register-shell.dark .invoice-clickable-row:hover,\n.invoice-register-shell.dark .invoice-register-row:hover {\n  background: #22252a;\n}\n.invoice-register-row.selected {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.invoice-register-shell.dark .invoice-register-row.selected {\n  background: #233331;\n}\n.invoice-register-row--loading {\n  cursor: default !important;\n  pointer-events: none !important;\n}\n.invoice-register-shell.dark .invoice-theme-select > button,\n.invoice-register-shell.dark .invoice-theme-options {\n  border-color: #3a3f47;\n  background: #191b1f;\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-register-shell.dark .invoice-theme-options button {\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-register-shell.dark .invoice-theme-options button:hover,\n.invoice-register-shell.dark .invoice-theme-options button.selected {\n  background: #233331;\n  color: var(--interactive-hover, #83c7be);\n}\n@media (max-width: 1190px) {\n  .invoice-table-head,\n  .invoice-register-row {\n    grid-template-columns: 112px minmax(132px, 1fr) 96px 104px 105px 118px 100px 138px 54px;\n  }\n  .invoice-register-row > * {\n    padding-left: 9px;\n    padding-right: 9px;\n  }\n  .invoice-table-head > span {\n    padding: 0 9px;\n  }\n}\n@media (max-width: 1024px) {\n  .invoice-register-main {\n    margin-left: 0;\n  }\n  .invoice-register-content {\n    padding: 24px;\n  }\n  .invoice-compact-org {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n  }\n  .invoice-compact-org > button {\n    display: grid;\n    width: 44px;\n    height: 44px;\n    place-items: center;\n    border: 1px solid #dce3e2;\n    border-radius: 10px;\n    background: var(--surface-secondary, #f4f7f7);\n  }\n  .invoice-compact-org > span {\n    margin-right: auto;\n    margin-left: 8px;\n    color: var(--text-secondary, #506360);\n    font-size: 13px;\n  }\n  .invoice-compact-org > div {\n    display: flex;\n    width: 220px;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    box-sizing: border-box;\n    border: 1px solid #dce3e2;\n    border-radius: 10px;\n    background: var(--surface-primary, #fff);\n  }\n  .invoice-compact-org i {\n    display: grid;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 32px;\n    place-items: center;\n    border: 1px solid #dce3e2;\n    border-radius: 50%;\n    background: var(--interactive-soft, #f0f8f7);\n    color: var(--interactive-default, #0f766e);\n    font-size: 11px;\n    font-style: normal;\n  }\n  .invoice-compact-org strong {\n    display: flex;\n    min-width: 0;\n    flex: 1;\n    flex-direction: column;\n    font-size: 13px;\n  }\n  .invoice-compact-org small {\n    margin-top: 3px;\n    color: var(--text-secondary, #506360);\n    font-size: 11px;\n    font-weight: 400;\n  }\n  .invoice-page-header h1 {\n    font-size: 28px;\n    line-height: 35px;\n  }\n  .invoice-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n  .invoice-summary-grid article:last-child {\n    grid-column: 1/-1;\n  }\n  .invoice-filter-row label {\n    flex: 1;\n    width: auto;\n  }\n  .invoice-table-head.desktop {\n    display: none;\n  }\n  .invoice-table-head.compact {\n    display: grid;\n    grid-template-columns:\n      minmax(210px, 1.4fr) minmax(150px, 1fr) minmax(145px, 1fr)\n      54px;\n  }\n  .invoice-register-row {\n    grid-template-columns:\n      minmax(210px, 1.4fr) minmax(150px, 1fr) minmax(145px, 1fr)\n      54px;\n    min-height: 80px;\n  }\n  .invoice-register-row .invoice-number {\n    grid-column: 1;\n    grid-row: 1;\n    align-self: center;\n    margin-top: 18px;\n  }\n  .invoice-register-row .invoice-customer {\n    grid-column: 1;\n    grid-row: 1;\n    align-self: start;\n    padding-bottom: 0;\n  }\n  .invoice-register-row .invoice-date {\n    grid-column: 1;\n    grid-row: 1;\n    align-self: end;\n    padding-top: 0;\n    color: var(--text-secondary, #506360);\n    font-size: 12px;\n  }\n  .invoice-register-row .invoice-due {\n    grid-column: 2;\n    grid-row: 1;\n    align-self: end;\n    color: var(--text-secondary, #506360);\n    font-size: 12px;\n  }\n  .invoice-register-row .invoice-status {\n    grid-column: 3;\n    grid-row: 1;\n    align-self: center;\n  }\n  .invoice-register-row .invoice-lifecycle-status {\n    grid-column: 3;\n    grid-row: 1;\n    align-self: start;\n  }\n  .invoice-register-row .invoice-total {\n    grid-column: 3;\n    grid-row: 1;\n    align-self: start;\n  }\n  .invoice-register-row .invoice-balance {\n    grid-column: 3;\n    grid-row: 1;\n    align-self: end;\n  }\n  .invoice-register-row .invoice-row-menu {\n    grid-column: 4;\n    grid-row: 1;\n  }\n  .invoice-register-row .invoice-check {\n    grid-column: 1;\n    grid-row: 1;\n  }\n  .invoice-menu-popover {\n    right: 8px;\n  }\n}\n@media (max-width: 600px) {\n  .invoice-register-content {\n    padding: 16px;\n  }\n  .invoice-compact-org > div {\n    width: auto;\n    max-width: 190px;\n  }\n  .invoice-compact-org > span {\n    font-size: 11px;\n  }\n  .invoice-page-header {\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n  .invoice-page-header > div p {\n    max-width: 230px;\n    font-size: 12px;\n    line-height: 17px;\n  }\n  .invoice-page-header .invoice-scope,\n  .invoice-page-header .invoice-snapshot {\n    font-size: 11px;\n  }\n  .invoice-new-button {\n    padding: 0 12px;\n  }\n  .invoice-summary-grid {\n    grid-template-columns: 1fr;\n  }\n  .invoice-summary-grid article:last-child {\n    grid-column: auto;\n  }\n  .invoice-summary-grid article {\n    min-height: 126px;\n    padding: 16px;\n  }\n  .invoice-summary-note {\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-tabs button {\n    padding: 0 10px;\n    font-size: 11px;\n  }\n  .invoice-filter-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n  .invoice-filter-row label {\n    grid-column: 1/-1;\n  }\n  .invoice-filter-row select {\n    width: 100%;\n    max-width: none;\n    font-size: 11px;\n  }\n  .invoice-register-context {\n    font-size: 11px;\n  }\n  .invoice-register-context span {\n    font-size: 10px;\n  }\n  .invoice-table-head.compact {\n    grid-template-columns:\n      minmax(120px, 1.4fr) minmax(92px, 1fr) minmax(90px, 1fr)\n      36px;\n    font-size: 9px;\n  }\n  .invoice-register-row {\n    grid-template-columns:\n      minmax(120px, 1.4fr) minmax(92px, 1fr) minmax(90px, 1fr)\n      36px;\n    min-height: 112px;\n    font-size: 11px;\n  }\n  .invoice-register-row > * {\n    padding: 10px 5px;\n  }\n  .invoice-check input {\n    width: 14px;\n    height: 14px;\n  }\n  .invoice-customer {\n    font-size: 11px;\n    line-height: 15px;\n  }\n  .invoice-register-row .invoice-number {\n    margin-top: 20px;\n    font-size: 11px;\n  }\n  .invoice-register-row .invoice-date,\n  .invoice-register-row .invoice-due,\n  .invoice-status small,\n  .invoice-balance small {\n    font-size: 9px;\n    line-height: 13px;\n  }\n  .invoice-total,\n  .invoice-balance strong {\n    font-size: 10px;\n    line-height: 14px;\n  }\n  .invoice-row-menu {\n    padding: 4px 0;\n  }\n  .invoice-row-menu > button {\n    width: 30px;\n  }\n  .invoice-menu-popover {\n    right: 0;\n  }\n  .invoice-register-card footer {\n    padding: 0 10px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 1024px) and (min-width: 601px) {\n  .invoice-register-row {\n    min-height: 136px;\n  }\n  .invoice-table-head.compact {\n    min-height: 64px;\n  }\n}\n\n@media (max-width: 600px) {\n  .invoice-theme-select {\n    min-width: 0;\n    width: 100%;\n  }\n  .invoice-theme-select > button {\n    width: 100%;\n    min-width: 0;\n    padding: 0 10px;\n    font-size: 11px;\n  }\n  .invoice-theme-options {\n    right: auto;\n    left: 0;\n    width: max-content;\n    max-width: calc(100vw - 32px);\n  }\n  .invoice-table-head.compact {\n    display: none;\n  }\n  .invoice-register-card {\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n  .invoice-register-context {\n    padding: 0 0 12px;\n  }\n  .invoice-table-body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .invoice-register-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 32px;\n    grid-template-rows: auto auto auto auto auto;\n    min-height: 0;\n    padding: 16px 12px;\n    border: 1px solid #dce3e2;\n    border-radius: 14px;\n    background: var(--surface-primary, #fff);\n  }\n  .invoice-register-row > * {\n    padding: 3px 0;\n  }\n  .invoice-register-row .invoice-number {\n    grid-column: 1;\n    grid-row: 1;\n    margin: 0;\n    align-self: auto;\n    font-size: 12px;\n  }\n  .invoice-register-row .invoice-row-menu {\n    grid-column: 2;\n    grid-row: 1/3;\n    align-self: center;\n  }\n  .invoice-register-row .invoice-customer {\n    grid-column: 1;\n    grid-row: 2;\n    font-size: 13px;\n    line-height: 18px;\n  }\n  .invoice-register-row .invoice-date {\n    grid-column: 1/3;\n    grid-row: 3;\n    align-self: auto;\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-register-row .invoice-status {\n    grid-column: 2;\n    grid-row: 5;\n    align-self: center;\n  }\n  .invoice-register-row .invoice-lifecycle-status {\n    grid-column: 2/4;\n    grid-row: 4;\n    align-self: center;\n  }\n  .invoice-register-row .invoice-due {\n    grid-column: 2/4;\n    grid-row: 6;\n    align-self: auto;\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-register-row .invoice-total {\n    grid-column: 2;\n    grid-row: 7;\n    align-self: auto;\n    justify-self: start;\n    margin-top: 8px;\n    font-size: 13px;\n    text-align: left;\n  }\n  .invoice-register-row .invoice-total:before {\n    content: \"Invoice total\";\n    display: block;\n    margin-bottom: 4px;\n    color: var(--text-secondary, #506360);\n    font: 400 10px/14px var(--font-family-primary);\n  }\n  .invoice-register-row .invoice-balance {\n    grid-column: 2/4;\n    grid-row: 7;\n    align-self: auto;\n    justify-self: end;\n    margin-top: 8px;\n  }\n  .invoice-register-row .invoice-balance strong {\n    font-size: 13px;\n  }\n  .invoice-register-row.selected {\n    border-color: #0f8b83;\n    background: var(--surface-primary, #fff);\n  }\n  .invoice-register-card footer {\n    margin-top: 12px;\n    border: 1px solid #dce3e2;\n    border-radius: 10px;\n    background: var(--surface-primary, #fff);\n  }\n  .invoice-selection-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    margin-bottom: 20px;\n  }\n  .invoice-selection-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n  .invoice-selection-heading h1 {\n    margin: 0;\n    font-size: 18px;\n    line-height: 25px;\n    font-weight: 500;\n  }\n  .invoice-selection-heading button {\n    height: 40px;\n    padding: 0 12px;\n    border: 1px solid #cdd6d4;\n    border-radius: 10px;\n    background: transparent;\n    color: var(--text-primary, #142624);\n    font: 500 13px var(--font-family-primary);\n  }\n  .invoice-selection-panel article {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n    border: 1px solid #dce3e2;\n    border-radius: 14px;\n    background: var(--surface-primary, #fff);\n  }\n  .invoice-selection-panel article div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .invoice-selection-panel article svg {\n    color: var(--interactive-default, #0f766e);\n  }\n  .invoice-selection-panel article b {\n    font-family: var(--font-family-mono, monospace);\n    font-size: 24px;\n  }\n  .invoice-selection-panel article p {\n    margin: 0;\n    color: var(--text-secondary, #506360);\n    font-size: 13px;\n  }\n  .invoice-reminder-button {\n    height: 44px;\n    border: 0;\n    border-radius: 10px;\n    background: #0f837a;\n    color: #fff;\n    font: 500 13px var(--font-family-primary);\n  }\n  .selection-active .invoice-page-header,\n  .selection-active .invoice-summary-grid,\n  .selection-active .invoice-summary-note,\n  .selection-active .invoice-filter-area,\n  .selection-active .invoice-register-context,\n  .selection-active .invoice-register-card footer {\n    display: none;\n  }\n  .selection-active .invoice-register-row:not(.selected) {\n    display: none;\n  }\n  .selection-active .invoice-register-card {\n    background: transparent;\n  }\n}\n\n/* Figma mobile invoice register (721:143044 / 721:146141). */\n.invoice-select-button,\n.invoice-selection-guidance {\n  display: none;\n}\n\n@media (max-width: 600px) {\n  .invoice-register-content {\n    padding: 16px 12px 24px;\n  }\n  .invoice-compact-org {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 10px;\n    margin: 0 0 20px;\n  }\n  .invoice-compact-org > button {\n    display: none;\n  }\n  .invoice-compact-org > span {\n    margin: 0;\n    color: var(--text-secondary, #506360);\n    font-size: 10px;\n    line-height: 14px;\n  }\n  .invoice-compact-org > div {\n    width: 100%;\n    max-width: none;\n    min-height: 64px;\n    padding: 10px 12px;\n    border-radius: 10px;\n  }\n  .invoice-compact-org strong {\n    font-size: 13px;\n    line-height: 18px;\n  }\n  .invoice-compact-org small {\n    margin-top: 0;\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .invoice-page-header {\n    grid-template-columns: 1fr auto;\n    gap: 10px 12px;\n    margin-bottom: 20px;\n  }\n  .invoice-page-header > div {\n    grid-column: 1/-1;\n  }\n  .invoice-page-header h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.25px;\n  }\n  .invoice-page-header > div p {\n    max-width: none;\n    margin-top: 2px;\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-new-button {\n    grid-column: 1/-1;\n    grid-row: 2;\n    width: 100%;\n    height: 40px;\n  }\n  .invoice-page-header .invoice-scope,\n  .invoice-page-header .invoice-snapshot {\n    margin: 0;\n    font-size: 10px;\n    line-height: 15px;\n  }\n  .invoice-page-header .invoice-scope {\n    grid-column: 1;\n    grid-row: 3;\n  }\n  .invoice-page-header .invoice-snapshot {\n    grid-column: 2;\n    grid-row: 3;\n    align-self: start;\n    white-space: nowrap;\n  }\n\n  .invoice-summary-grid {\n    gap: 10px;\n  }\n  .invoice-summary-grid article {\n    min-height: 116px;\n    gap: 10px;\n    padding: 14px;\n    border-radius: 10px;\n  }\n  .invoice-summary-grid h2 {\n    font-size: 15px;\n    line-height: 21px;\n  }\n  .invoice-summary-grid article > strong {\n    font-size: 20px;\n    line-height: 25px;\n  }\n  .invoice-summary-grid article > p {\n    font-size: 10px;\n    line-height: 15px;\n  }\n  .invoice-summary-note {\n    margin: 10px 0 18px;\n  }\n\n  .invoice-filter-area {\n    margin-bottom: 20px;\n  }\n  .invoice-tabs {\n    margin: 0 -12px;\n    padding: 0 12px;\n  }\n  .invoice-tabs button {\n    height: 36px;\n    padding: 0 8px;\n    font-size: 9px;\n  }\n  .invoice-filter-row {\n    gap: 8px;\n    margin-top: 10px;\n  }\n  .invoice-filter-row label,\n  .invoice-clear-filters,\n  .invoice-theme-select > button {\n    height: 36px;\n    border-radius: 8px;\n  }\n  .invoice-filter-row input,\n  .invoice-clear-filters,\n  .invoice-theme-select > button {\n    font-size: 10px;\n  }\n  .invoice-filter-area > p {\n    margin-top: 8px;\n    font-size: 9px;\n    line-height: 14px;\n  }\n\n  .invoice-register-context {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 8px;\n    height: auto;\n    padding: 0 0 12px;\n  }\n  .invoice-register-context strong {\n    font-size: 11px;\n  }\n  .invoice-register-context span {\n    grid-column: 1/-1;\n    grid-row: 2;\n    font-size: 9px;\n  }\n  .invoice-select-button {\n    display: inline-flex;\n    grid-column: 2;\n    grid-row: 1;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n    padding: 0 10px;\n    border: 1px solid #cdd6d4;\n    border-radius: 8px;\n    background: var(--surface-primary, #fff);\n    color: var(--text-primary, #142624);\n    font: 500 10px var(--font-family-primary);\n  }\n\n  .invoice-table-body {\n    gap: 8px;\n  }\n  .invoice-register-row {\n    grid-template-columns: minmax(0, 1fr) 28px;\n    grid-template-rows: repeat(7, auto);\n    gap: 0;\n    padding: 12px;\n    border-radius: 10px;\n  }\n  .invoice-register-row .invoice-number {\n    grid-column: 1;\n    grid-row: 1;\n    font-size: 10px;\n    line-height: 15px;\n  }\n  .invoice-register-row .invoice-row-menu {\n    grid-column: 2;\n    grid-row: 1/3;\n    align-self: start;\n  }\n  .invoice-register-row .invoice-customer {\n    grid-column: 1;\n    grid-row: 2;\n    font-size: 10px;\n    line-height: 15px;\n  }\n  .invoice-customer small {\n    margin-top: 2px;\n    font-size: 9px;\n    line-height: 14px;\n  }\n  .invoice-register-row .invoice-lifecycle-status {\n    grid-column: 1/-1;\n    grid-row: 3;\n    margin-top: 4px;\n  }\n  .invoice-register-row .invoice-due {\n    grid-column: 1/-1;\n    grid-row: 4;\n    margin-top: 2px;\n    font-size: 9px;\n    line-height: 14px;\n  }\n  .invoice-register-row .invoice-status {\n    grid-column: 1/-1;\n    grid-row: 5;\n    margin-top: 2px;\n  }\n  .invoice-register-row .invoice-date {\n    grid-column: 1/-1;\n    grid-row: 6;\n    margin-top: 3px;\n    font-size: 9px;\n    line-height: 14px;\n  }\n  .invoice-register-row .invoice-date:before {\n    content: \"Invoice date \";\n    color: var(--text-secondary, #506360);\n  }\n  .invoice-register-row .invoice-total {\n    grid-column: 1;\n    grid-row: 7;\n    margin-top: 6px;\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-register-row .invoice-total:before {\n    margin-bottom: 1px;\n    font-size: 8px;\n    line-height: 12px;\n  }\n  .invoice-register-row .invoice-balance {\n    grid-column: 2;\n    grid-row: 7;\n    margin-top: 6px;\n  }\n  .invoice-register-row .invoice-balance small {\n    margin: 0 0 1px;\n    font-size: 8px;\n    line-height: 12px;\n  }\n  .invoice-register-row .invoice-balance strong {\n    font-size: 11px;\n    line-height: 16px;\n  }\n  .invoice-row-menu > button {\n    height: 24px;\n  }\n  .invoice-register-card footer {\n    display: none;\n  }\n\n  .selection-active .invoice-page-header {\n    display: grid;\n  }\n  .selection-active .invoice-page-header .invoice-new-button {\n    display: none;\n  }\n  .selection-active .invoice-page-header .invoice-scope {\n    grid-row: 2;\n  }\n  .selection-active .invoice-page-header .invoice-snapshot {\n    grid-row: 2;\n  }\n  .selection-active .invoice-summary-grid,\n  .selection-active .invoice-summary-note,\n  .selection-active .invoice-filter-area,\n  .selection-active .invoice-register-context {\n    display: none;\n  }\n  .invoice-selection-panel {\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n  .invoice-selection-heading h1 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .invoice-selection-heading button {\n    height: 34px;\n    padding: 0 10px;\n    border-radius: 8px;\n    font-size: 10px;\n  }\n  .invoice-selection-panel article {\n    gap: 8px;\n    padding: 12px;\n    border-radius: 10px;\n  }\n  .invoice-selection-panel article strong,\n  .invoice-selection-panel article p {\n    font-size: 10px;\n    line-height: 15px;\n  }\n  .invoice-selection-panel article b {\n    font-size: 18px;\n    line-height: 24px;\n  }\n  .invoice-reminder-button {\n    height: 38px;\n    border-radius: 8px;\n    font-size: 11px;\n  }\n  .selection-active .invoice-register-row .invoice-check {\n    display: block;\n  }\n  .invoice-selection-guidance {\n    margin: 10px 0 0;\n    color: var(--text-secondary, #506360);\n    font-size: 9px;\n    line-height: 14px;\n  }\n  .selection-active .invoice-selection-guidance {\n    display: block;\n  }\n}\n\n.invoice-check input:disabled {\n  background: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-subtle, #dce3e2);\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n/* Keep register headings and row contents on matching column edges. */\n@media (min-width: 1024px) {\n  .invoice-register-card {\n    --invoice-register-columns: minmax(112px, 1fr) minmax(150px, 1.35fr)\n      minmax(100px, 0.9fr) minmax(112px, 0.95fr) minmax(108px, 0.95fr)\n      minmax(124px, 1.05fr) minmax(104px, 0.9fr) minmax(144px, 1.15fr) 64px;\n  }\n  .invoice-register-card .invoice-table-head.desktop,\n  .invoice-register-card .invoice-register-row {\n    grid-template-columns: var(--invoice-register-columns);\n  }\n  .invoice-register-card .invoice-table-head.desktop > span,\n  .invoice-register-card .invoice-register-row > * {\n    padding-inline: 16px;\n    text-align: left;\n  }\n  .invoice-register-card .invoice-table-head.desktop > span:nth-child(7),\n  .invoice-register-card .invoice-table-head.desktop > span:nth-child(8),\n  .invoice-register-card .invoice-register-row .invoice-total,\n  .invoice-register-card .invoice-register-row .invoice-balance {\n    text-align: right;\n  }\n  .invoice-register-card .invoice-table-head.desktop > span:last-child {\n    padding-inline: 8px;\n    text-align: center;\n  }\n  .invoice-register-card .invoice-register-row .invoice-row-menu {\n    justify-content: center;\n    padding-inline: 8px;\n  }\n  .invoice-register-card .invoice-number,\n  .invoice-register-card .invoice-customer {\n    white-space: normal;\n    overflow-wrap: break-word;\n  }\n}\n@media (min-width: 601px) {\n  .invoice-register-card .invoice-table-head > span.invoice-check,\n  .invoice-register-card .invoice-register-row > .invoice-check {\n    text-align: center;\n  }\n}\n@media (min-width: 601px) and (max-width: 1024px) {\n  .invoice-register-card .invoice-table-head.compact > span,\n  .invoice-register-card .invoice-register-row > * {\n    padding-inline: 12px;\n  }\n  .invoice-register-card .invoice-table-head.compact > span:nth-child(4),\n  .invoice-register-card .invoice-table-head.compact > span:last-child {\n    text-align: right;\n  }\n  .invoice-register-card .invoice-register-row .invoice-row-menu {\n    justify-content: flex-end;\n  }\n}\n.invoice-empty {\n  display: flex;\n  min-height: 220px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 8px;\n  padding: 32px 20px;\n  color: var(--text-secondary, #506360);\n  text-align: center;\n}\n.invoice-empty > svg {\n  width: 28px;\n  height: 28px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-empty > strong {\n  color: var(--text-primary, #142624);\n  font-size: 16px;\n  font-weight: 500;\n}\n.invoice-empty > span {\n  font-size: 13px;\n}\n.invoice-empty > button {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 0 14px;\n  border: 1px solid var(--interactive-default, #0f766e);\n  border-radius: 9px;\n  background: var(--surface-primary, #fff);\n  color: var(--interactive-default, #0f766e);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.invoice-empty > button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n/* Create Invoice Type Modal — Figma Node 1898:111001 */\n.invoice-creation-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(20, 38, 36, 0.45);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: invoiceFadeIn 0.2s ease-out;\n}\n\n/* The global .dark background is opaque and !important. Keep this backdrop\n   translucent so the existing blur can sample the page in dark mode too. */\n.invoice-creation-modal-backdrop.dark {\n  background-color: var(--overlay-default) !important;\n}\n\n@keyframes invoiceFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.invoice-creation-modal {\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 32px);\n  max-height: calc(100dvh - 32px);\n  border-radius: 14px;\n  background: #ffffff;\n  border: 1px solid #dce3e2;\n  box-shadow: 0 20px 40px -8px rgba(20, 38, 36, 0.16);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.invoice-creation-modal > :not(.invoice-creation-modal-body) {\n  flex-shrink: 0;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-modal {\n  background: #1b2423;\n  border-color: #2e3d3b;\n  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.4);\n}\n\n/* Header */\n.invoice-creation-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 28px 28px 20px 28px;\n}\n\n.invoice-creation-modal-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.invoice-creation-header-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: #15703d;\n  flex-shrink: 0;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-header-icon {\n  color: #4ade80;\n}\n\n.invoice-creation-modal-header-left h2 {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 25px;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-modal-header-left h2 {\n  color: #f0f4f3;\n}\n\n.invoice-creation-modal-close {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  color: #506360;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.invoice-creation-modal-close:hover {\n  background: #f4f7f7;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-modal-close {\n  color: #9eaeac;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-modal-close:hover {\n  background: #243331;\n  color: #f0f4f3;\n}\n\n.invoice-creation-divider {\n  height: 1px;\n  background: #dce3e2;\n  width: 100%;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-divider {\n  background: #2e3d3b;\n}\n\n/* Subtitle Description */\n.invoice-creation-description {\n  margin: 0;\n  padding: 24px 28px 0 28px;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-description {\n  color: #9eaeac;\n}\n\n/* Body */\n.invoice-creation-modal-body {\n  padding: 24px 28px;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Options Grid */\n.invoice-creation-options-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 540px) {\n  .invoice-creation-options-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.invoice-creation-card {\n  padding: 16px;\n  border-radius: 10px;\n  border: 1px solid #cdd6d4;\n  background: #f4f7f7;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-card {\n  border-color: #2e3d3b;\n  background: #141e1d;\n}\n\n.invoice-creation-card:hover {\n  border-color: #0f766e;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-card:hover {\n  border-color: #14b8a6;\n}\n\n.invoice-creation-card.is-selected {\n  border: 1px solid #0f766e;\n  background: #f0f8f7;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-card.is-selected {\n  border-color: #14b8a6;\n  background: rgba(15, 118, 110, 0.2);\n}\n\n.invoice-creation-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.invoice-creation-radio {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid #cdd6d4;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.invoice-creation-card.is-selected .invoice-creation-radio {\n  border-color: #0f766e;\n  background: #0f766e;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-radio {\n  border-color: #4a5f5c;\n  background: #141e1d;\n}\n\n.invoice-creation-modal-backdrop.dark\n  .invoice-creation-card.is-selected\n  .invoice-creation-radio {\n  border-color: #14b8a6;\n  background: #14b8a6;\n}\n\n.invoice-creation-radio .radio-inner {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #ffffff;\n}\n\n.invoice-creation-card-icon {\n  font-size: 20px;\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-card-icon {\n  color: #14b8a6;\n}\n\n.invoice-creation-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.choice-title {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 19.5px;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .choice-title {\n  color: #f0f4f3;\n}\n\n.choice-description {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .choice-description {\n  color: #9eaeac;\n}\n\n/* Quotation Selection Flow */\n.invoice-creation-quote-flow {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.invoice-creation-dropdown-group {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.invoice-creation-label-row {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.invoice-creation-label {\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.25px;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-label {\n  color: #f0f4f3;\n}\n\n.required-marker {\n  color: #c23a2b;\n  font-weight: 500;\n}\n\n.invoice-creation-trigger-container {\n  position: relative;\n  height: var(--control-md, 40px);\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid #cdd6d4;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 12px;\n  border-radius: 4px;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n  line-height: 17.5px;\n  color: #142624;\n  cursor: pointer;\n  transition: background 0.1s ease;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item {\n  color: #f0f4f3;\n}\n\n.dropdown-menu-item:hover:not(.is-disabled) {\n  background: #f4f7f7;\n}\n\n.invoice-creation-modal-backdrop.dark\n  .dropdown-menu-item:hover:not(.is-disabled) {\n  background: #243331;\n}\n\n.dropdown-menu-item.is-selected {\n  background: #f0f8f7;\n  color: #0f766e;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-selected {\n  background: rgba(15, 118, 110, 0.25);\n  color: #2dd4bf;\n}\n\n.dropdown-menu-item.is-disabled {\n  color: #8a9896;\n  cursor: not-allowed;\n  background: transparent;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-disabled {\n  color: #657976;\n}\n\n.dropdown-item-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown-item-check {\n  font-size: 16px;\n  color: #0f766e;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-item-check {\n  color: #2dd4bf;\n}\n\n.dropdown-loading-item,\n.dropdown-empty-item {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-trigger-container {\n  background: #141e1d;\n  border-color: #2e3d3b;\n}\n\n.invoice-creation-trigger-container.is-active,\n.invoice-creation-trigger-container:focus-within {\n  border-color: #0f766e;\n  box-shadow: none;\n}\n\n.invoice-creation-modal-backdrop.dark\n  .invoice-creation-trigger-container.is-active,\n.invoice-creation-modal-backdrop.dark\n  .invoice-creation-trigger-container:focus-within {\n  border-color: #14b8a6;\n  box-shadow: none;\n}\n\n.trigger-search-icon {\n  font-size: 16px;\n  color: #506360;\n  flex-shrink: 0;\n}\n\n.invoice-creation-modal-backdrop.dark .trigger-search-icon {\n  color: #9eaeac;\n}\n\n.trigger-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  flex: 1;\n  min-width: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n  line-height: 17.5px;\n  color: #142624;\n  width: 100%;\n}\n\n.trigger-search-input::placeholder {\n  color: #6b7b78;\n}\n\n.invoice-creation-modal-backdrop.dark .trigger-search-input {\n  color: #f0f4f3;\n}\n\n.invoice-creation-modal-backdrop.dark .trigger-search-input::placeholder {\n  color: #7e9290;\n}\n\n.trigger-chevron {\n  font-size: 16px;\n  color: #506360;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.trigger-chevron.open {\n  transform: rotate(180deg);\n}\n\n.invoice-creation-trigger-container .invoice-quotation-search-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 var(--control-sm, 32px);\n  width: var(--control-sm, 32px);\n  height: var(--control-sm, 32px);\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.invoice-quotation-search-toggle:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.invoice-creation-dropdown-menu .dropdown-menu-item.is-active {\n  background: var(--interactive-soft, #f0f8f7);\n}\n\n.invoice-creation-modal-backdrop.dark .trigger-chevron {\n  color: #9eaeac;\n}\n\n.invoice-creation-guidance {\n  margin: 4px 0 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-guidance {\n  color: #9eaeac;\n}\n\n/* Dropdown Menu */\n.invoice-creation-dropdown-menu {\n  position: fixed;\n  box-sizing: border-box;\n  z-index: 1300;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid #cdd6d4;\n  box-shadow: 0 10px 24px -4px rgba(20, 38, 36, 0.12);\n  padding: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: min(240px, 30vh);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.invoice-creation-dropdown-menu .dropdown-menu-item {\n  min-height: 36px;\n  flex-shrink: 0;\n  gap: 8px;\n  padding: 8px 10px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.invoice-creation-dropdown-menu .dropdown-item-label {\n  min-width: 0;\n  font: inherit;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-dropdown-menu {\n  background: #1b2423;\n  border-color: #2e3d3b;\n  box-shadow: 0 10px 24px -4px rgba(0, 0, 0, 0.4);\n}\n\n.dropdown-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 12px;\n  border-radius: 4px;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n  line-height: 17.5px;\n  color: #142624;\n  cursor: pointer;\n  transition: background 0.1s ease;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item {\n  color: #f0f4f3;\n}\n\n.dropdown-menu-item:hover:not(.is-disabled) {\n  background: #f4f7f7;\n}\n\n.invoice-creation-modal-backdrop.dark\n  .dropdown-menu-item:hover:not(.is-disabled) {\n  background: #243331;\n}\n\n.dropdown-menu-item.is-selected {\n  background: #f0f8f7;\n  color: #0f766e;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-selected {\n  background: rgba(15, 118, 110, 0.25);\n  color: #2dd4bf;\n}\n\n.dropdown-menu-item.is-disabled {\n  color: #8a9896;\n  cursor: not-allowed;\n  background: transparent;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-menu-item.is-disabled {\n  color: #657976;\n}\n\n.dropdown-item-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown-item-check {\n  font-size: 16px;\n  color: #0f766e;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-item-check {\n  color: #2dd4bf;\n}\n\n.dropdown-loading-item,\n.dropdown-empty-item {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .dropdown-loading-item,\n.invoice-creation-modal-backdrop.dark .dropdown-empty-item {\n  color: #9eaeac;\n}\n\n/* Selected Quotation Preview Section */\n.invoice-creation-preview-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.preview-section-title {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-section-title {\n  color: #f0f4f3;\n}\n\n.invoice-creation-preview-card {\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid #cdd6d4;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-preview-card {\n  background: #141e1d;\n  border-color: #2e3d3b;\n}\n\n.preview-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.preview-quote-number {\n  font-family: \"JetBrains Mono\", \"Roboto Mono\", monospace;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-quote-number {\n  color: #f0f4f3;\n}\n\n.preview-badge-accepted {\n  border-radius: 999px;\n  background: #edfbf2;\n  padding: 3px 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-badge-accepted {\n  background: rgba(21, 112, 61, 0.25);\n}\n\n.preview-badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #15703d;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-badge-dot {\n  background: #4ade80;\n}\n\n.preview-badge-label {\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n  color: #115a33;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-badge-label {\n  color: #4ade80;\n}\n\n.preview-client-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.preview-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 16px;\n  background: #f0f8f7;\n  border: 1px solid #dce3e2;\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-avatar {\n  background: #1e2d2b;\n  border-color: #2e3d3b;\n  color: #2dd4bf;\n}\n\n.preview-client-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.preview-client-name {\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-client-name {\n  color: #f0f4f3;\n}\n\n.preview-dates-line {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  line-height: 18px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-dates-line {\n  color: #9eaeac;\n}\n\n.preview-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-top: 4px;\n}\n\n.preview-item-row {\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  line-height: 20px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-item-row {\n  color: #9eaeac;\n}\n\n.preview-subtotal-line {\n  margin: 4px 0 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  line-height: 20px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-subtotal-line {\n  color: #9eaeac;\n}\n\n.preview-card-divider {\n  height: 1px;\n  background: #dce3e2;\n  width: 100%;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-card-divider {\n  background: #2e3d3b;\n}\n\n.preview-card-footer {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\n.preview-total-amount {\n  font-family: \"JetBrains Mono\", \"Roboto Mono\", monospace;\n  font-size: 16px;\n  font-weight: 600;\n  color: #142624;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-total-amount {\n  color: #f0f4f3;\n}\n\n.preview-total-label {\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 12px;\n  color: #6b7b78;\n}\n\n.invoice-creation-modal-backdrop.dark .preview-total-label {\n  color: #7e9290;\n}\n\n.invoice-conversion-rule-note {\n  margin: 0;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20.2px;\n  color: #506360;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-conversion-rule-note {\n  color: #9eaeac;\n}\n\n/* Footer */\n.invoice-creation-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 28px;\n}\n\n.invoice-creation-btn-cancel {\n  height: 40px;\n  padding: 0 18px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  border: 1px solid #cdd6d4;\n  background: #ffffff;\n  color: #142624;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-btn-cancel {\n  border-color: #2e3d3b;\n  background: #1e2d2b;\n  color: #f0f4f3;\n}\n\n.invoice-creation-btn-cancel:hover {\n  background: #f4f7f7;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-btn-cancel:hover {\n  background: #263836;\n}\n\n.invoice-creation-btn-submit {\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  border: none;\n  background: #0f766e;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.invoice-creation-btn-submit:hover:not(:disabled) {\n  background: #0d645d;\n}\n\n.invoice-creation-btn-submit:disabled {\n  background: #cdd6d4;\n  color: #8a9896;\n  cursor: not-allowed;\n}\n\n.invoice-creation-modal-backdrop.dark .invoice-creation-btn-submit:disabled {\n  background: #2e3d3b;\n  color: #7e9290;\n}\n\n.invoice-register-row:not(.invoice-register-row--loading) {\n  cursor: pointer;\n}\n.invoice-register-row:not(.invoice-register-row--loading):hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.invoice-register-row.selected:hover {\n  background: #f0f8f7;\n}\n.invoice-register-shell.dark\n  .invoice-register-row:not(.invoice-register-row--loading):hover {\n  background: #22252a;\n}\n.invoice-contact-link {\n  color: var(--text-primary, #142624);\n  font: inherit;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n.invoice-contact-link:hover {\n  text-decoration: underline !important;\n  color: var(--text-link, #0f766e);\n}\n.invoice-contact-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.invoice-register-shell .invoice-theme-select.open > button,\n.invoice-register-shell .invoice-theme-select > button:focus-visible,\n.invoice-register-shell .invoice-filter-row > label:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n  outline: none;\n}\n\n.invoice-register-shell\n  .invoice-theme-select:has(> button[aria-label=\"Customer filter\"])\n  > .invoice-theme-options {\n  box-sizing: border-box;\n  max-height: min(240px, 40vh);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n}\n\n.invoice-bank-gate-backdrop {\n  position: fixed;\n  z-index: 1500;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: var(--overlay-default, rgba(10, 22, 20, 0.44));\n}\n\n.invoice-bank-gate-dialog {\n  width: min(520px, 100%);\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-xl, 20px);\n  background: var(--surface-elevated, #fff);\n  box-shadow: 0 6px 8px rgba(14, 26, 32, 0.1),\n    0 1px 1px rgba(14, 26, 32, 0.04);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.invoice-bank-gate-dialog header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 28px 20px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.invoice-bank-gate-dialog header > svg {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.invoice-bank-gate-dialog h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 26px;\n}\n\n.invoice-bank-gate-dialog header button {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.invoice-bank-gate-dialog header button svg {\n  width: 20px;\n  height: 20px;\n}\n\n.invoice-bank-gate-copy {\n  padding: 24px 28px 0;\n}\n\n.invoice-bank-gate-copy p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.invoice-bank-gate-dialog footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 28px;\n}\n\n.invoice-bank-gate-dialog footer button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  font: 500 13px/17px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n\n.invoice-bank-gate-secondary {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n\n.invoice-bank-gate-primary {\n  border: 1px solid var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n\n@media (max-width: 560px) {\n  .invoice-bank-gate-dialog header,\n  .invoice-bank-gate-copy,\n  .invoice-bank-gate-dialog footer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .invoice-bank-gate-dialog h2 {\n    font-size: 18px;\n    line-height: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
